module.exports = {
  ICON_FONT_PREFIX: 'cs-icon',
};
